import { NavigationGuardNext, Route, RouteConfig } from 'vue-router'
import { routes } from '@/router/index'
import store from '@/store'
import { PermissionPageManager } from '@/api/permissions/pages'
import { permissions } from '@/api/permissions/permissions'
import Config from '@/config/default/config'
import { authRouteNames } from '@/router/pages/auth'

function findPathByName(name: string) {
  const routerPages: RouteConfig[] | undefined = routes[0].children
  if (routerPages) {
    return routerPages.find(r => r.meta?.navbar?.displayName === name)
  }
}

function getURLAfterAuth(isAuthed: boolean) {
  const myPublications = findPathByName('Мои публикации')
  const allPublications = findPathByName('Все публикации')
  const isDirector = store.getters['user/isDirector']
  if (isAuthed) {
    return isDirector ? allPublications!.path : myPublications!.path
  } else {
    return allPublications!.path
  }
}

export const beforeEachRoute = (
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
) => {
  // Change NavBar title
  store.commit(
    'navBarTitle/setTitleFromRoute',
    { width: window?.innerWidth ?? Config.defaultWidth, to: to },
    { root: true }
  )

  const isAuthed = store.getters['user/isAuthenticated']

  const abilities = PermissionPageManager.pages()
  const pageName: string = to.name ? to.name : ''
  const canViewThisPage = abilities.can(permissions.viewPage, pageName)

  // Change redirect URL
  routes[0].redirect = getURLAfterAuth(isAuthed)

  // if it's redirect, do redirect
  if (routes.find(r => r.redirect === to.path)) {
    return next()
  }

  if (!isAuthed) {
    // if this page without auth, redirect to page to.path
    if (canViewThisPage) {
      return next()
    } else {
      return next({
        name: authRouteNames.AuthMainRoute,
        query: { redirect: to.fullPath }
      })
    }
  }

  if (isAuthed && !canViewThisPage && to.path !== '/error') {
    const user = store.getters['user/currentUser']
    const name =
      user && user.initials ? user.initials : 'Неизвестный пользователь'
    store.dispatch('toast/pushToast', {
      title: 'Авторизация',
      message: `Выполнена авторизация в системе от имени <b>${name}</b>. Данный пользователь не имеет прав на просмотр страницы.`
    })
  }

  if (!canViewThisPage) {
    return next('/error')
  }

  next()
}
